import { render } from "./MatchBracket.vue?vue&type=template&id=2edb7960&scoped=true"
import script from "./MatchBracket.vue?vue&type=script&lang=js"
export * from "./MatchBracket.vue?vue&type=script&lang=js"

import "./MatchBracket.vue?vue&type=style&index=0&id=2edb7960&scoped=true&lang=css"
import "./MatchBracket.vue?vue&type=style&index=1&id=2edb7960&lang=css"
import "./MatchBracket.vue?vue&type=style&index=2&id=2edb7960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edb7960"]])

export default __exports__